"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createReducer(handlers, initialState) {
    if (initialState === void 0) { initialState = Object.create({}); }
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        var newState;
        if (handlers[action.type]) {
            newState = handlers[action.type](state, action);
        }
        if (newState) {
            return newState;
        }
        return state;
    };
}
exports.default = createReducer;
